export default "__VITE_ASSET__7d122200__"